import React, { useState } from "react";
import ChairLiftUsers from "../ChairLift/ChairLiftusers";
const BoatingUsers = () => {
  

  return (
    <div className="col-12">
      <ChairLiftUsers serviceId={8} Service="Boating" />
    </div>
  );
};
export default BoatingUsers
